/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { TmHttpClient } from '@treasury/core/http';
import { Injectable } from '@treasury/utils/dependency-injection';
import { createSwaggerClient } from '../../utils/tm-swagger-client';

import { HttpClient, RequestParams } from './http-client';

@Injectable()
export class WarmupClient {
    private readonly http: HttpClient;

    constructor(tmHttp: TmHttpClient) {
        this.http = createSwaggerClient(tmHttp, HttpClient);
    }

    /**
     * No description
     *
     * @tags Warmup
     * @name WarmupGet
     * @summary Warmup Action
     * @request GET:/warmup
     */
    warmupGet = (params: RequestParams = {}) =>
        this.http.request<string, any>({
            path: `/warmup`,
            method: 'GET',
            format: 'json',
            ...params,
        });
}
